import { useState, useRef, useEffect, useContext } from 'react';
import Drawer from '@material-ui/core/Drawer';
import TextField from '@material-ui/core/TextField';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Button, Toast } from 'react-weui';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import CompanyService from 'services/company2';
import WorkflowService from 'services/workflow2';
import { ActionContext } from 'actions/context';
import Modal from 'services/modal';
import Util from 'lib/util';
/**
 * 审批流按钮组件
 */
function WorkflowButtons(props) {
  const [optXkNoList, setOptXkNoList] = useState([]); //审批人
  const [reason, setReason] = useState('');
  const [employeeList, setEmployeeList] = useState([]);
  const {
    companyCode,
    id,
    detail,
    workflow,
    sourcePage,
    onComplete,
    applyValidate
  } = props;

  const { state, dispatch } = useContext(ActionContext);
  const { showWfConfirm, actionId } = state;

  let btnItem = {};
  //创建实例，用于储存非状态可变值
  let instant = useRef({
    btnItem
  });
  let self = instant.current;

  useEffect(() => {
    //设置下一关审批人
    if (props.companyCode) {
      CompanyService.getStaffList(props.companyCode).then(arr => {
        setEmployeeList(arr);
      });
    }
  }, [props.companyCode]);

  function hideWfConfirm() {
    dispatch({ type: 'hideWfConfirm' });
  }

  //初始化审批流（仅在审核页面需调此方法）
  async function initWorkflow() {
    //流程配置
    if (workflow.wfmCode && typeof companyCode === 'string') {
      await WorkflowService.init(companyCode, workflow, id).then(async res => {
        if (workflow.isActive) {
          await WorkflowService.getStatus(
            companyCode,
            [detail],
            workflow,
            true
          );
        }
      });
    }
  }

  //工作流状态流转（按钮点击）
  async function wfTransfer(item) {
    let billXkNo = detail[workflow.billXkNoField];
    //审核列表的按钮默认显示，点击后初始化
    if (sourcePage === 'approveList') {
      workflow.wfmCode = detail.wfmCode;
      item.wfnXkNo = detail.curNodeXkNo;
      item.wfTypeCode = detail.billWfTypeCode;
      await initWorkflow();
    }
    if (item.isReset) {
      //撤回
      WorkflowService.reset(
        companyCode,
        billXkNo,
        detail,
        workflow,
        item,
        dispatch
      );
    } else if (item.isApply) {
      //送审
      // 送审前业务校验
      if (typeof applyValidate === 'function') {
        const isValid = await applyValidate();
        if (!isValid) {
          return;
        }
      }

      self.btnItem.isApply = true; //标识是否送审
      self.btnItem.wfTypeCode = item.wfTypeCode;
      if (WorkflowService.checkSelectNext(item, workflow)) {
        //设置下一关审批人
        CompanyService.getStaffList(companyCode).then(arr => {
          if (Util.isEmpty(item.nextEmployeeList)) {
            setEmployeeList(arr);
          } else {
            // 根据设置过滤员工列表
            setEmployeeList(
              arr.filter(row => item.nextEmployeeList.includes(row.id))
            );
          }
        });
        self.btnItem = Object.assign({}, item); //切断引用
        self.btnItem.checkStatus = 1;
        self.btnItem.isSelectNext = true; //标识是否设置下一关
        setOptXkNoList([]);
      }

      setReason('');
      dispatch({ type: 'showWfConfirm', actionId: detail.id });
    } else {
      if (
        WorkflowService.checkSelectNext(item, workflow) &&
        item.checkStatus === 1
      ) {
        //设置下一关审批人
        CompanyService.getStaffList(companyCode).then(arr => {
          if (Util.isEmpty(item.nextEmployeeList)) {
            setEmployeeList(arr);
          } else {
            // 根据设置过滤员工列表
            setEmployeeList(
              arr.filter(row => item.nextEmployeeList.includes(row.id))
            );
          }
        });
        self.btnItem = Object.assign({}, item); //切断引用
        self.btnItem.isSelectNext = true; //标识是否设置下一关
        setReason('同意');
        setOptXkNoList([]);
        dispatch({ type: 'showWfConfirm', actionId: detail.id });
      } else {
        WorkflowService.transfer(
          companyCode,
          billXkNo,
          detail,
          workflow,
          item,
          dispatch,
          data => {
            if (data?.autoPublishFlag === 1) {
              if (typeof onComplete === 'function') {
                onComplete(data);
              }
            }
          }
        );
      }
    }
  }

  //设置下一关审批人
  function approve() {
    let billXkNo = detail[workflow.billXkNoField];
    if (validate()) {
      self.btnItem.reasonStr = reason;
      self.btnItem.optXkNoList = optXkNoList;
      WorkflowService.transfer(
        companyCode,
        billXkNo,
        detail,
        workflow,
        self.btnItem,
        dispatch
      );
    }
  }

  //送审
  function setApplyStatus() {
    if (!validate()) {
      return;
    }

    let billXkNo = detail[workflow.billXkNoField];
    self.btnItem.optXkNoList = optXkNoList;
    WorkflowService.setApplyStatus(
      companyCode,
      billXkNo,
      self.btnItem,
      1,
      reason,
      rs => {
        if (rs) {
          WorkflowService.getStatus(companyCode, [detail], workflow, true);
          dispatch({ type: 'hideWfConfirm' });
        }
      },
      dispatch
    );
  }

  function validate() {
    if (
      self.btnItem.isApply &&
      self.btnItem.checkStatus === 1 &&
      Util.isEmpty(reason)
    ) {
      Modal.showError('送审说明不能为空', dispatch);
      return false;
    }

    if (self.btnItem.checkStatus === 0 && Util.isEmpty(reason)) {
      Modal.showError('退回原因不能为空', dispatch);
      return false;
    } else if (
      !self.btnItem.isApply &&
      self.btnItem.checkStatus === 1 &&
      Util.isEmpty(reason)
    ) {
      Modal.showError('审批意见不能为空', dispatch);
      return false;
    } else if (self.btnItem.isSelectNext && Util.isEmpty(optXkNoList)) {
      Modal.showError('审批人不能为空', dispatch);
      return false;
    }
    return true;
  }

  function reasonChange(event) {
    setReason(event.target.value);
  }

  function handleChangeMultiple(event) {
    setOptXkNoList(event.target.value);
  }

  function renderValue(selected) {
    let arr = [];
    optXkNoList.forEach(code => {
      let name = employeeList.filter(item => item.id === code)[0].text;
      arr.push(name);
    });
    return arr.join(', ');
  }

  let btns = workflow.arrBtn?.map((item, i) => (
    <Button
      type="default"
      key={i}
      onClick={() => {
        wfTransfer(item);
      }}
      className={
        'm-flex-item u-btn ' +
        (item.checkStatus === 0 ? 'u-btn_warn' : 'u-btn_green')
      }
    >
      {item.btnName}
    </Button>
  ));

  return workflow.arrBtn?.length === 0 ? (
    ''
  ) : (
    <div className="m-flex-box m-flex-item">
      {btns}
      <Drawer anchor="bottom" open={showWfConfirm && actionId === detail.id}>
        {(self.btnItem.isApply || self.btnItem.isReset) && (
          <DialogTitle id="customized-dialog-title">
            您是否确认此操作？
          </DialogTitle>
        )}
        <div className="MuiDrawer-paper">
          {self.btnItem.isSelectNext && self.btnItem.checkStatus === 1 && (
            <div className="text-field-item mb10">
              <FormControl fullWidth>
                <InputLabel>指定下一关审批人</InputLabel>
                <Select
                  multiple
                  value={optXkNoList}
                  onChange={handleChangeMultiple}
                  input={<Input />}
                  renderValue={renderValue}
                >
                  {employeeList.map((item, index) => (
                    <MenuItem key={index} value={item.id}>
                      <Checkbox checked={optXkNoList.includes(item.id)} />
                      <ListItemText primary={item.text} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          )}
          <div className="text-field-item">
            <TextField
              id="approve"
              label={self.btnItem.isApply ? '送审说明' : '审批意见'}
              value={reason}
              onChange={reasonChange}
              margin="normal"
              rows="3"
              multiline
              fullWidth
              variant="outlined"
            />
          </div>
          <p className="mt15 m-flex-box">
            <Button
              type="default"
              className="m-flex-item u-btn u-btn_line"
              onClick={hideWfConfirm}
            >
              取消
            </Button>
            {self.btnItem.isApply ? (
              <Button
                type="default"
                className="m-flex-item u-btn u-btn_primary"
                onClick={() => {
                  setApplyStatus();
                }}
              >
                确定
              </Button>
            ) : (
              <Button
                type="default"
                className="m-flex-item u-btn u-btn_primary"
                onClick={() => {
                  approve();
                }}
              >
                确定
              </Button>
            )}
          </p>
        </div>
      </Drawer>
    </div>
  );
}

export default WorkflowButtons;
